export const locale = {
  lang: 'es',
  data: {
    'REQUERIMIENTOS': {

      'BOTONES':{
        'SIGUIENTE': 'Siguiente',
        'ANTERIOR': 'Anterior',
        'FINALIZAR': 'Finalizar',
        'ACEPTAR': 'Acepto los requerimientos técnicos '
      },
      'MENSAJES': {
        'CONFREQ': 'Ha aceptado los requerimientos técnicos de la plataforma correctamente',
        'OK':'OK',
      },
      'CABECERA':{
        'TITULO': 'Requerimientos técnicos',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
      'PASO1':{
        'TITULO': 'Requisitos del colaborador',
        'SUB_TITULO': '1. Requerimientos de la aplicación',
        'SUB_TITULO2': '2. Requisitos de capacidad del navegador',
        'TABLE_REQUERIMIENTOS' : {
          'TD_SISTEMAS': 'Sistemas operativos:',
          'TD_LABEL_RECOMENDADO': 'o superior (RECOMENDADO).',
          'TD_NAVEGADOR': 'Navegador: ',
          'TD_LABEL_SUPERIOR': 'o superior.',
          'TD_LABEL_LASTVERSION': '(última versión).',
          'TD_LABEL_LASTVERSION_MIN': '(ultima versión, version mínima 12.3).'
        },
        'TABLE_REQUISITOS' : {
          'TD_CERTIFICAR': 'Certificado de seguridad: ',
          'TD_COOKIES': 'Cookies permitidas: ',
          'TD_CIFRADO': 'Cifrado TLS: ',

          'TD_CONTENT1': 'Asegúrese de que el certificado de seguridad o la autoridad del otorgante Let’s Encrypt Authority X3 es clasificado como confiable por su organización.',
          'TD_CONTENT2': 'El navegador debe tener habilitado JavaScript 1.2.',
          'TD_CONTENT3': 'Los servidores de la plataforma CULTURAL GO® manejan cookies, las cuales no recolectan información del usuario ni de su sistema operativo pero son requeridas para la operación de la encuesta y deben estar habilitadas.',
          'TD_CONTENT4': 'Dependiendo del tipo de proyecto, uno de nuestros módulos de informes requiere cifrado solo TLS.'
        },
        'PARRAFO1': {
          'SUBPARRAFO1': 'Si el cliente tiene la intención de usar otro sistema operativo, que no sean los listados anteriormente tales como versiones de LINUX, UNIX, ChromeOS, Sistemas operativos móviles, etc., el cliente es responsable de garantizar que la encuesta se ejecute correctamente en el software de su navegador.',
          'SUBPARRAFO2': 'Debido a la vulnerabilidad de POODLE (CVE-2014-3566) y la terminación del soporte para Windows XP por parte de Microsoft, Great Place to Work® ya no admitirá el acceso a nuestros sitios web seguros desde computadoras que ejecutan Windows XP. Great Place to Work® mantendrá el soporte para computadoras con Windows XP que utilizan versiones de los navegadores Chrome o Firefox que figuran en los requisitos de la aplicación. El acceso aún puede estar disponible desde otros navegadores; sin embargo, esos navegadores no serán probados ni soportados.'
        },
        'ADVERT': 'NOTA: A partir de la versión 5.0 de Cultural Go se retira el soporte a Microsoft Internet Explorer.'
      },
      'PASO2':{
        'TITULO': 'Autenticación de encuesta',
        'SUB_TITULO1': '3. Certificados',
        'SUB_TITULO2': '4. Computadora/computadora portatil del colaborador',
        'SUB_TITULO3': '5. Respuesta de la encuesta desde dispositivos móviles',
        'SUB_TITULO4': '1. Cuestiones a considerar',
        'SUB_TITULO5': '2. Ayuda de idioma',
        'PARRAFO1': 'La plataforma CULTURAL GO® utiliza el certificado SSL Let´s Encrypt Authority X3 provisto por Internet Security Research Group (ISRG). En caso de que el certificado no esté presente se mostrará una página de advertencia de seguridad al usuario informándole que hay un problema con el certificado de seguridad del sitio web. El usuario puede seleccionar continuar con el acceso al sitio web o mostrar más información sobre el tema. Aunque el usuario puede continuar en el sitio web, el mensaje de advertencia seguirá apareciendo cada vez que se acceda al sitio.',
        'PARRAFO2':{
          'LINEA1':'Para acceder a la encuesta en línea, la computadora/laptop del colaborador necesita: ',
          'LINEA2':'Acceso completo a la dirección web de la encuesta (asegúrese de que el usuario tenga los permisos adecuados en caso de tener un firewall.).',
          'LINEA3':'En caso de que se envíe por correo el enlace de la encuesta, el usuario debe tener acceso a su cuenta de correo electrónico corporativo.',
        },
        'PARRAFO3': 'La encuesta ha sido validada en dispositivos móviles, tales como tabletas y teléfonos. La presentación y acomodo de los elementos de la encuesta se acoplará a la resolución de la pantalla del dispositivo. Depende del modelo del dispositivo para que la encuesta pueda ejecutarse.',

        'PARRAFO4': 'La encuesta ha sido diseñada para tener una agradable experiencia de usuario en las pantallas verticales de los dispositivos móviles con resolución Full HD.',

        'PARRAFO5': 'En muchas organizaciones, las redes WiFi no dan acceso completo a navegación a los dispositivos personales, si el usuario decide utilizar su dispositivo personal y conectarse a través de una red WiFi, deberá validar que tenga acceso al sitio web de la encuesta.',

        'PARRAFO6': 'El usuario debe estar consciente que si utiliza conexión directa a su compañía celular, los cargos por navegación pueden aplicarle.',
        'PARRAFO7':{
          'LINEA1':'Los usuarios obtendrán acceso al sitio mediante el uso de una URL específica que se genera para cada proyecto. Las ligas no contienen ninguna información del usuario.',
          'LINEA2':'Se debe ingresar un código de usuario único en la URL global segura para permitir el acceso a la encuesta.',
          'LINEA3':'El código de usuario único le será proporcionado a cada usuario, ya sea por correo electrónico, SMS, o bien, se le hará llegar manualmente por medio de su Coordinador de Recursos Humanos (o puesto equivalente).',
        },
        'PARRAFO8':{
          'LINEA1':'1. El cliente debe controlar la entrega de la invitación por correo electrónico a sus empleados:',
          'LINEA2':'Si el servidor de correo electrónico se subcontrata, comuníquese previamente con el proveedor de correo electrónico para informar los requisitos.',
          'LINEA3':'Si el servidor de correo electrónico está en sus instalaciones, solicite ayuda al departamento de TI.',
          'LINEA4':'Nota: El envío de las invitaciones para responder la encuesta no se podrá enviar a clientes de correo electrónico gratuitos como: Hotmail, Gmail, Yahoo, etc.',
          'LINEA5':'2. Si el correo electrónico corporativo del cliente es OUTLOOK WEBACCESS, los empleados tendrán que copiar el enlace web y abrirlo en el navegador web, de lo contrario, se generará un error.',
          'LINEA6':'3. Dejar la encuesta inactiva en la computadora o dispositivo donde se realiza la encuesta durante más de 30 minutos generará un "TIEMPO DE ESPERA", y tendrá que volver a registrarse en la encuesta, con la misma contraseña. El sistema lo llevará a la pregunta exacta en la que se encontraba.',
          'LINEA7':'4. Cada respuesta es guardada al momento de seleccionarla. No podrá seleccionar ninguna otra respuesta hasta que el proceso de guardado termine, garantizando así que el avance del usuario al responder la encuesta ha sido guardada.',
        },
        'PARRAFO9':{
          'LINEA1':'Nuestra encuesta solo admite los idiomas configurados en el selector de idioma y solo se puede seleccionar al comienzo de la encuesta.',
          'LINEA2':'En caso de que los idiomas seleccionados estén en cualquier idioma que requiera caracteres especiales, el usuario debe asegurarse de que su navegador admita las fuentes.',
          'LINEA3':'Por lo general, todos los usuarios que tienen la intención de ver la encuesta en cualquier idioma que requiera caracteres especiales, ya tienen instalados paquetes de idiomas, por lo que es posible que esto no sea necesario para todos los usuarios, a excepción de algunos.',
          'LINEA4':'Si requiere el uso de una fuente específica para algún proyecto en el sitio, los usuarios deben tener esa fuente específica instalada en cada una de sus máquinas respectivas. Cuando sea necesario, Great Place to Work® comunicará dichos requisitos al equipo del proyecto del cliente.',
        },
        'PARRAFO10': 'Importante: El usuario debe asegurarse de que el navegador no tenga activa la función de traducción automática, de lo contrario, el selector de idioma podría no funcionar.',
      },
      'PASO3':{
        'TITULO': 'Requisitos de conexión a internet',
        'SUB_TITULO1': '1. Requisitos de encriptación SSL',
        'SUB_TITULO2': '2. Requisitos de ancho de banda',
        'SUB_TITULO3': '3. Firewall Whitelists: IP del servidor web y acceso al dominio',
        'SUB_TITULO4': '4. Firewall Whitelists: servidor de correo electrónico',
        'SUB_TITULO5': '5. Generación de grupos (Kioskos) de respuesta',
        'PARRAFO1': 'El navegador web del cliente debe admitir sitios habilitados para SSL. Esto permite al usuario la máxima privacidad de la información personalizada.',

        'PARRAFO2': 'El ancho de banda depende del tipo de encuesta e informes que se implementen y los componentes (video e imágenes) utilizados. Para encuestas con estos componentes, la conexión recomendada es de 1+ Mbit / s por usuario. La usabilidad se verá afectada si se utiliza una conexión inferior. Para encuestas con ninguno de estos componentes, se requiere una conexión normal a internet.',

        'PARRAFO3':{
          'LINEA1':'Lo siguiente debe aparecer en los sitios de encuestas e informes para trabajar en CULTURAL GO®: whitelists',
          'LINEA2':'Es importante otorgar los permisos necesarios a los siguientes dominios y direcciones IP para permitir que sus empleados accedan a la encuesta Great Place to Work Trust Index®.',
        },
        'PARRAFO31': 'Importante: Los usuarios deben tener acceso completo e ilimitado (no restringido) a todo el dominio.',
        'PARRAFO4':{
          'LINEA1':'El servidor de correo requiere dar acceso completo a las siguientes direcciones de correo electrónico:',
          'LINEA2':'Es necesario que se otorguen los siguientes permisos en su servidor de correo para evitar que los correos electrónicos de Great Place to Work® se clasifiquen como spam:',
        },
        'PARRAFO5':{
          'LINEA1':'Importante:',
          'LINEA2':'Esta configuración es para evitar que la dirección de correo electrónico sea detectada como spam.',
          'LINEA3':'El servidor de correo debe poder recibir miles de correos electrónicos de la misma cuenta.',
          'LINEA4':'En las reglas de seguridad de su proveedor de correo electrónico, agregue los dominios y, si es posible, agregue los whitelist como cuentas de correo electrónico de contacto.',
        },
        'PARRAFO6': 'En muchas organizaciones es común colocar varias computadoras para que los usuarios puedan acudir a ellas a responder la encuesta. Es necesario que se hagan las pruebas suficientes de ancho de banda de las salidas a internet para asegurar que los dispositivos de conexión soporten todo el tráfico que se genera por la respuesta en grupo.',
        'PARRAFO7': 'Es recomendable que antes de que los usuarios comiencen a responder en grupo, un especialista del área de TI verifique que no haya problemas de conexión a internet.',
        'TABLA1':{
          'TD_ELEMENTO':'Elemento',
          'TD_REGION1':'Región México',
          'TD_REGION2':'Región Centro y Sudamérica',
          'TD_REGION3':'Región Asia',
          'TD_REGION4':'Región Europa',
          'TD_DOMINIO':'Dominio',
          'TD_SUBDOMINIO':'Subdominio',
          'TD_DIRECCION':'Dirección IP',
          'TD_PUERTOS':'Puertos',

        },
        'TABLA2':{
          'TD1':'Cuenta de correo del remitente:',
          'TD2':'Dominio'
        },
        'TABLADOMINIO':{
          'TD_ELEMENTO01':'Aplicación',
          'TD_ELEMENTO02':'Dominio',
          'TD_ELEMENTO03':'IP',
          'TD_ELEMENTO04':'Puerto',
          'TD_ELEMENTO05':'Subdominio',
        },
        'TITLE1':'Dominio: CulturalGo.com',
        'TITLE2':'Dominio: gptw.global',
      },
      'PASO4':{
        'TITULO': 'Niveles de servicio',
        'SUB_TITULO1': '1. Soporte',
        'SUB_TITULO2': '2. Disponibilidad del sistema',
        'SUB_TITULO3': '3. Fuerza mayor',
        'SUB_TITULO4': '4. Concurrencia',
        'SUB_TITULO5': '5. Ventana de mantenimiento',
        'TABLA1':{
          'TD_REGION1':'Región México',
          'TD_REGION2':'Región Centro y Sudamérica',
          'TD_REGION3':'Región Asia',
          'TD_REGION4':'Región Europa'
        },
        'PARRAFO1':{
          'LINEA1':'Disponibilidad de la aplicación = 99.5%',
          'LINEA2':'Para garantizar la disponibilidad del sistema, la aplicación se supervisa las 24 horas del día, los 7 días de la semana y los 365 días del año con un sistema de alerta y procedimientos de soporte.',
        },
        'PARRAFO2': 'Fuerza mayor significa eventos más allá del control razonable de una parte, incluidos, entre otros, guerra, huelgas, regulación gubernamental, disturbios civiles o actos de terrorismo o terremotos, que lo hacen legalmente impracticable, ilegal o imposible para tales partes el realizar sus funciones.',
        'PARRAFO3': 'El nivel de servicio de disponibilidad del sistema no cubre ninguna falta de servicio causada por el incumplimiento por parte del cliente de los requisitos técnicos establecidos en este documento, o cualquier evento clasificado como Fuerza mayor.',
        'PARRAFO4': 'El entorno de recopilación de datos puede admitir 10.000 usuarios simultáneos o completar hasta 1.5 millones de encuestas en un período de 24 horas. La aplicación de informes puede admitir 500 usuarios concurrentes o hasta 1,000 sesiones en un período de 24 horas.',
        'PARRAFO5':{
          'LINEA1':'Great Place to Work® se reserva el derecho de suspender la solicitud de encuestas e informes para el mantenimiento programado. Los horarios de mantenimiento programados se comunicarán con anticipación a todas las partes afectadas.',
          'LINEA2':'Durante la ventana de mantenimiento mencionada anteriormente, la aplicación puede no estar disponible para los usuarios. Si Great Place to Work® requiere una ventana de mantenimiento extendida para actividades adicionales, se notificará al contacto designado del cliente.',
          'LINEA3':'Para el mantenimiento de emergencia, es posible que no se anuncie la ventana de mantenimiento. Para los clientes afectados por el mantenimiento de emergencia, se notificará al contacto designado del cliente.'
        },
      },
      'PASO5':{
        'TITULO': 'Política de privacidad de datos',
        'SUB_TITULO1': '1. Política',
        'PARRAFO1': 'La información que se envía y almacena en los servidores de la Plataforma CULTURAL GO® está protegida y es resguardada bajo políticas y procedimientos que cumplen con lo dispuesto en la normativa ISO 27001. Cualquier duda que se tenga al respecto, consutle con su asesor de Great Place To Work®.',
      },
      'VALIDACION':{
        'TITULO': 'Validación de requerimientos técnicos',
        'DATOSTI':{
          'INFOEMPRESA': 'Información de la empresa',
          'NOMBREEMPRESA': 'Nombre de la empresa',
          'NOMBRE': 'Nombre del responsable de TI',
          'EMAIL': 'Correo electrónico',
          'TEL': 'Teléfono',
          'EXT': 'Extensión',
          'CEL': 'Teléfono celular',
          'TOOLTIP': 'Ver información de la empresa'
        },
        'TIMELINE':{
          'TITULO': 'Proceso de validación de requerimientos técnicos',
          'CARGANDO': 'Cargando la información',
          'PROGRESO': 'Progreso actual: ',
          'PROGRESO2': 'Progreso de validación de los requerimientos: ',
          'STATUS': {
            'OK': 'Estado: Completado',
            'NOTOK': 'Estado: No completado',
            'TOOLTIP': 'Marcar como completado'
          },
          'COMENTARIO': {
            'TITULO_1': 'Guarde un comentario acerca de este paso',
            'INPUT': 'Escriba su comentario',
            'ENVIAR': 'Enviar comentario',
            'TITULO_2': 'Comentarios (más antiguos primero)',
            'CANNOT': 'No se pueden enviar comentarios una vez que el paso ya está completado',
          },
          'NOMBRES': {
            '1': 'Envío de correo al responsable TI',
            '2': 'Configuración RT - Llamada al cliente',
            '3': 'Configuración RT - Pruebas',
            '4': 'Envío de cuestionario',
            '5': 'Fin del cuestionario'
          }
        },
        'MENSAJES': {
          'NADA': 'No ha escrito el comentario, no se puede guardar un comentario vacío',
          'AUNNO': 'Aún no puede realizar este paso, primero debe estar completa la validación de los requerimientos técnicos',
          'COMPLETAR': '¿Confirma cambiar el estado de este paso a "Completado"?',
          'COMPLETAR_OK': 'Este paso fue cambiado a "Completado" correctamente',
          'BOTONES': {
            'SI': 'Si',
            'NO': 'No'
          },
          'NOCOMPLETAR': 'No puede marcar como completo este paso todavía\n\nDebe completar primero el paso anterior'
        }
      }
    },
    'REQUERIMIENTOSV3':{
      'MENSAJES':{
        'MENSAJE_SUCCESS_OK':'Se actualizaron  los requerimientos técnicos',
        'MENSAJE_CONEX_OK':'Se realizo la conexión correctamente',
        'ACTUALIZANDO_REQUERIMIENTOS': 'Actualizando requerimientos técnicos',
        'MENSAJE_RESPUESTA_REQ':'* Respuesta requerida',
        'WAR_ING_CORR':'Ingrese mínimo un correo',
      },
      'CABECERA':{
        'TITULO': 'Requerimientos técnicos',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
       'BOTONES':{
              'SIGUIENTE': 'Siguiente',
              'ANTERIOR': 'Anterior',
              'FINALIZAR': 'Finalizar',
              'ACEPTAR': 'Acepto los requerimientos técnicos '
            },
        'PASO1':{
          'TITULO':'Requisitos del colaborador',
          'SUB_TITULO':'Requerimientos Técnicos',
          'SUB_TITULO2':'Plataforma CulturalGo® 5.0',
          'TEXTO0_PARTE_1':'El propósito del documento es dar a conocer los requisitos técnicos de la plataforma CulturalGo® para garantizar un acceso fácil y efectivo al sistema de encuestas Great Place to Work®, Trust índex© y con esto evitar problemas técnicos recurrentes.',
          'TEXTO0_PARTE_2':'Es esencial cumplir y verificar cada uno de los requisitos técnicos para que los colaboradores de su organización reciban y respondan a la encuesta, de lo contrario, es muy probable que haya complicaciones como bloqueos y/o interfaces que resulten que el colaborador no pueda recibir y responder la encuesta.',
          'SUB_TITULO3':'Requisitos del Colaborador (Usuario final)',
          'SUB_TITULO4':'Requisitos de la Aplicación',

          'SUB_TITULO2_CARCA':'Plataforma CulturalGo® 5.0',
          'TEXTO0_PARTE_1_CARCA':'El propósito del documento es dar a conocer los requisitos técnicos de la plataforma CulturalGo® para garantizar un acceso fácil y efectivo al sistema de encuestas Great Place to Work®, Trust Index© y con esto evitar problemas técnicos recurrentes.',
          'TEXTO0_PARTE_2_CARCA':'Es esencial cumplir y verificar cada uno de los requisitos técnicos para que los colaboradores de su organización reciban y respondan a la encuesta, de lo contrario, es muy probable que haya complicaciones como bloqueos y/o interfaces que resulten que el colaborador no pueda recibir y responder la encuesta.',
          'TEXTO0_PARTE_1_INNMO':'El propósito del documento es dar a conocer los requisitos técnicos de la plataforma CulturalGo® para garantizar un acceso fácil y efectivo al sistema de encuestas Innmotion, Trust Index© y con esto evitar problemas técnicos recurrentes.',

          'TABLE_REQUERIMIENTOS' : {
            'TD_SISTEMAS': 'Sistemas operativos:',
            'TD_LABEL_RECOMENDADO': 'o superior (RECOMENDADO).',
            'TD_NAVEGADOR': 'Navegador: ',
            'TD_LABEL_SUPERIOR': 'o superior.',
            'TD_LABEL_LASTVERSION': '(última versión).',
            'TD_LABEL_LASTVERSION_MIN': '(ultima versión, version mínima 12.3).'
          },
          'TEXTO1_PARTE_1':'Si el cliente tiene la intención de usar otro sistema operativo que no sean los listados anteriormente tales como versiones de LINUX, UNIX, Chrome OS, Sistemas Operativos móviles, etc., el cliente es responsable de garantizar que la encuesta se ejecute correctamente en el Software de su navegador.',
          'TEXTO1_PARTE_2':'Debido a la vulnerabilidad de POODLE (CVE-2014-3566) y la terminación del soporte para Windows XP por parte de Microsoft, Great Place to Work® ya no admitirá el acceso a nuestros sitios web seguros desde computadoras que ejecutan Windows XP. Great Place to Work® mantendrá el soporte para computadoras con Windows XP que utilizan versiones de los navegadores Chrome o Firefox que figuran en los requisitos de la aplicación. El acceso aún puede estar disponible desde otros navegadores; sin embargo, esos navegadores no serán probados NI SOPORTADOS.',

          'TEXTO1_PARTE_2_INNO':'Debido a la vulnerabilidad de POODLE (CVE-2014-3566) y la terminación del soporte para Windows XP por parte de Microsoft, Innmotion ya no admitirá el acceso a nuestros sitios web seguros desde computadoras que ejecutan Windows XP. Innmotion mantendrá el soporte para computadoras con Windows XP que utilizan versiones de los navegadores Chrome o Firefox que figuran en los requisitos de la aplicación. El acceso aún puede estar disponible desde otros navegadores; sin embargo, esos navegadores no serán probados NI SOPORTADOS.',
          'TEXTO2_PARTE_1':'Nota: A partir de la versión 5.0 CuturalGo® se retira el soporte a Microsoft Internet Explorer',
        },
        'PASO2':{
          'TITULO': 'Autenticación de encuesta',
          'SUB_TITULO1': ' IP del servidor web y acceso al dominio',
          'SUB_TITULO2': ' Firewall Whitelists:',
          'TEXTO0_PARTE_1': 'Lo siguiente debe aparecer en la whitelists para los sitios de encuestas e informes para trabajar en la Plataforma CulturalGo®:',
          'TEXTO1_PARTE_1': 'Es importante otorgar los permisos necesarios a los siguientes dominios y dirección IP para permitir que sus empleados accedan a la encuesta Great Place to Work®, Trust índex©',
          'TEXTO1_PARTE_1_INNMO': 'Es importante otorgar los permisos necesarios a los siguientes dominios y dirección IP para permitir que sus empleados accedan a la encuesta Innmotion, Trust índex©',
          'BTN_COMPRO_CONEX':'Comprobar conexión',
          'BTN_SUCCE_CONEX':'Conexión establecida',
          'TOOL_BTN_COMPRO_CONEX':'Servicio en construcción',
          'MODAL_SUCCESS_CONEX':'Se realizo la conexión correctamente',
          'ETI_INTRUC_DOMA_COPY':'Copie y envié este enlace en caso de que necesite verificar las conexiones desde cualquier punto de acceso descentralizado (No impacta en la validación de los Requerimientos Técnicos).',
          'BTN_INTRUC_COPY_ENLA':'Copiar enlace',
          'MODAL_COPY_ENLA_SUCC':'Se copio enlace correctamente',


          'SUB_TITULO2_CARCA': ' Firewall whilelists:',
          'TEXTO0_PARTE_1_CARCA': 'Lo siguiente debe aparecer en la whitelists para los sitios de encuestas e informes para trabajar en la Plataforma CulturalGo®:',
          'TEXTO1_PARTE_1_CARCA': 'Es importante otorgar los permisos necesarios a los siguientes dominios y dirección IP para permitir que sus empleados accedan a la encuesta Great Place to Work®, Trust Index©',




          'TABLE_CONTEN':{
           'TH_ELEMENTO':'Elemento',
           'TH_REGIONM':'Región global',
           'TH_REGIONC':'Region Centro y Sur America',
           'TH_REGIONA':'Region Asia',
           'TH_REGIONE':' Region Europa',
           'TH_DOMINIO_PRINCIPAL':'Dominio Principal',
           'TH_APLICADOR':'Aplicador de Encuesta',
           'TH_PLATAFORMA':'Plataforma de Administración',
           'TH_ENVOLTURA':'Envoltura de Url',
           'TH_RESULTADOS':' Resultados (Tableau®)',
           'TH_CULTURE':'Culture Audit®',
           'TH_PORTAL':'Portal de conteos Externo',
           'TH_SUBDOMINIO':'Subdominio',
           'TH_DIRECCION_IP':'Dirección IP',
           'TH_PUERTOS':'Puertos',
           'TH_DOMINIO':'Dominio',
           'TEXTO1':'•	Todos los links a las encuestas, serán entregados por medio de la envoltura de URL 4all.gptw.global/ , la cual contiene una redirección al sitio ﬁnal de la encuesta asignada para cada empresa.',
           'TEXTO2':'• Por temas de seguridad, los algoritmos de CulturalGo® podrán cambiar el URL de la encuesta ﬁnal en cualquier momento durante el periodo de la encuesta, es por eso que siempre se debe utilizar la envoltura 4all.gptw.global/ la cual es permantente durante toda la encuesta.',
           'TEXTO3':'IMPORTANTE:',
           'TEXTO4':'Nunca debe accederse directamente al link de la encuesta (por ejemplo: http://newsurvey.culturalgo.com/Ax013s203ls) ya que el token que la compone puede variar ocasionalmente y sin previo aviso.',
           'TEXTO5':'Importante:',
           'TEXTO6':'Los usuarios deben tener acceso completo e ilimitado (no restringido) a todo el dominio.',
           'TEXTO7':'servidor de correo electrónico',
           'TEXTO8':'El servidor de correo requiere dar acceso completo a las siguientes direcciones de correo electrónico:',
           'TEXTO9':'Es necesario que se otorguen los siguientes permisos en su servidor de correo para evitar que los correos electrónicos de Great Place to Work® se clasiﬁquen como SPAM:',
           'TEXTO9_INNMO':'Es necesario que se otorguen los siguientes permisos en su servidor de correo para evitar que los correos electrónicos de Innmotion se clasiﬁquen como SPAM:',
           'TABLA_CONTENT2':{
             'TD_CUENTA_CORREO':'Cuenta de correo del remitente:',
             'TD_DOMINIO':'Dominio:',
             'TD_IP_ADDRE_PRIM':'Dirección IP primaria:',
             'TD_SECON_IP':'Direcciones IP secundarias:',
             'TD_SUBDOMINIO':'Subdominios para redirección de enlaces (Se utilizan para monitorización):',
           },
           'TEXTO10':'•	Esta conﬁguración es para evitar que la dirección de correo electrónico sea detectada como spam.',
           'TEXTO11':'•	El servidor de correo debe poder recibir miles de correos electrónicos de la misma cuenta.',
           'TEXTO12':'•	En las reglas de seguridad de su proveedor de correo electrónico, agregue los dominios para la whitelist y, si es posible, agréguelos como cuentas de correo electrónico de contacto',
           'TEXTO13':'Si requieres apoyo envía un mensaje a :',
           'BTN_CONFIGURACION':'Se configuraron los dominios e IP´S',
           'BTN_ACCESO_ENCUESTA':'Realicé las pruebas y no tuve complicaciones',
           'BTN_RECIBI_CORREOS':'Recibí los correos en bandeja de entrada',

          }
        },
        'PASO3':{
          'TITULO':'Pruebas de acceso',
          'TIT_TES_PRU_ACC_SURV':'En esta sección podrá realizar una prueba de visualización de una encuesta genérica (ajena a la de su organización):',
          'INS2_TES_PRU_ACC_SURV':'1. De clic en: ',
          'INS1_1_TES_PRU_ACC_SURV':'Copiar clave:',
          'INS1_TES_PRU_ACC_SURV':'2. Acceda al siguiente enlace:',
          'INS3_TES_PRU_ACC_SURV':'3. Pegue la clave en la celda de contraseña',
          'INS4_TES_PRU_ACC_SURV':'4. De clic en iniciar sesión',
          'TIT_TES_PRU_EM_PILO':'En esta sección podrá realizar una prueba de recepción del correo',
          'INS1_TES_PRU_EM_PILO':'1. Introduzca los correos electrónicos',
          'INS2_TES_PRU_EM_PILO':'2. De clic en el botón "Envío del correo de prueba"',
          'BTN_SE_EMA':'Envío del correo de prueba',
          'CONTAC':'En caso de tener errores técnicos escríbanos a support@itbm.mx con gusto lo podemos resolver.',
          'WARN_TEST_EMAIL':'Para continuar con el proceso le hemos enviado una liga de confirmación a su correo electrónico',
          'MSJ_SUCC_EMA_':'Se enviaron correctamente los correos electrónicos',
          'MODAL_WARNI_BAND':'Para continuar con el proceso confirme el acceso a la encuesta y/o la recepción del correo electrónico',
          'MODAL_VERIFI_INFO':'Verificando información',
          'MSJ_COP_CLA':'Copiando clave de usuario',

          'MODAL_WARNI_EMAL':'IMPORTANTE: Este link no debe ser compartido con los colaboradores de la organización, debido a que es un link prueba con el fin de validar que se han otorgado los permisos necesarios en la apertura de la encuesta.',
          'CONTAC_CARCA':'En caso de tener errores técnicos escríbanos a soporte_ca@gptwonline.com con gusto lo podemos resolver.',
          'WARN_TEST_EMAIL_CARCA':'Para continuar con el proceso le hemos enviado un link de confirmación a su correo electrónico',

        },
        'PASO4':{
          'TITULO':'Cuestionario de validación',
          'PREGUNTAS':{
            'PREGUNTA_1':'1.-¿Realizo las configuraciones sin ningún problema?',
            'PREGUNTA_1_INDI':'(De haber tenido algún problema por favor especifique)',
            'PREGUNTA_2':'2.-Las confiuraciones de su servidor de correo fueron realizar por:',
            'PREGUNTA_2_INDI1':'a) Su equipo Interno de IT( tiene el control total de las Configuraciones).',
            'PREGUNTA_2_INDI2':'b) Solicito ticket a su proveedor (menciona nombre del proveedor)',
            'PREGUNTA_3':'3.-¿Sus correos electrónicos estan bajo cuentas empresariales (Gmail, Microsoft, Yahoo!, etc.)?',
            'PREGUNTA_4':'4.-¿Dio de alta el dominio @gptwonline.com?, recordar que los correos que recibe son de este dominio,asegurar que no se hayan ido a spam o a correo no deseado?',
            'PREGUNTA_5':'5.-¿Tiene forma de obtener listado de correos recibidos (Email log)??',
            'PREGUNTA_6':'6.-¿Qué navegadores de internet tienen instalados sus colaboradores? (Por Favor liste; Navegador – versión)',
            'PREGUNTA_7':'7.-¿Concedió los permisos necesarios para que sus colaboradores puedan navegar en la encuesta? (Si presento algún problema por favor especifique)',
            'PREGUNTA_8':'8.-¿Para la aplicación de su encuesta tiene planeado salas de cómputo para que sus colaboradores contesten su encuesta?',
            'PREGUNTA_8_INDI1':'(¿De ser afirmativo por favor indíquela cantidad de salas y el número de equipos por sala?)',
          },
          'BTN_VALIDAR_ENVIAR':'Validar y enviar',
        },
        'PASO5':{
          'TITULO': 'Política de privacidad de datos',
          'SUB_TITULO':'Política de privacidad de Datos',
          'PARRAFO1': 'La información que se envía y almacena en los servidores de la Plataforma CULTURAL GO® está protegida y es resguardada bajo políticas y procedimientos que cumplen con lo dispuesto en la normativa ISO 27001. Cualquier duda que se tenga al respecto, consulte con su asesor de Great Place To Work®.',
          'PARRAFO1_INNMO': 'La información que se envía y almacena en los servidores de la Plataforma CULTURAL GO® está protegida y es resguardada bajo políticas y procedimientos que cumplen con lo dispuesto en la normativa ISO 27001. Cualquier duda que se tenga al respecto, consulte con su asesor de Innmotion.',
          'PARRAFO2':'Marcas Registradas',
          'PARRAFO3_1':'•	Great Place to Work® y Trust Index© ',
          'PARRAFO3_2':'son marcas registradas por Great Place To Work Institute USA, en este documento sólo se utilizan estas marcas como referencia.',
          'PARRAFO3_1_INNMO':'•	Innmotion y Trust Index© ',
          'PARRAFO3_2_INNMO':'son marcas registradas por Innmotion Institute USA, en este documento sólo se utilizan estas marcas como referencia.',
          'PARRAFO4_1':'•	Cultural Go®, SuccessGo® ',
          // 'PARRAFO4_2':'Es una marca registradda por Innovación Tecnológica B&M S.A. de C.V. México',
          'PARRAFO4_2':'y en general toda la plataforma Go!® son marcas registradas por el desarrollador',
          'PARRAFO5':'Gracias!!',
          'BTN_FINALIZAR':'Finalizar y enviar',
          'BTN_FINA_REQUE':'Requerimientos técnicos finalizados',


        },
        'COPY_MESSAGE':'Clave copiada al portapaleles',
        'COMPR_CONEXI':'Comprobando la conexión',
        'SUCCES_CONF_EMA': {
          'MODAL_SUCCESS':'Se ha validado la recepción de los correos',
          'MODAL_INSTRUCCI':'Por favor cierre la pestaña',
        },
        'FORMULARIO_TI': {
          'TAB': 'Fin del proceso',
          'TITULO': 'Datos del revisor',
          'SUBTITULO': 'Para concluír el proceso, ingrese sus datos en el siguiente formulario y haga clic en el botón Finalizar',
          'DONE': 'Ya ha finalizado el proceso',
          'FINALIZAR': 'Finalizar requerimientos técnicos',
          'NOTYET': 'El responsable TI no ha concluído el proceso, podrá confirmar los requerimientos técnicos hasta el responsable TI haya introducido sus datos',
          'FORM': {
            'NOMBRE': 'Nombre',
            'MAIL': 'Correo electrónico',
            'FECHA': 'Fecha de finalización',
            'SINENVIAR': 'Datos aún no enviados'
          },
          'MENSAJES': {
            'NOMBRE': 'No ha introducido su nombre en el campo indicado',
            'GUARDANDO': 'Se está guardando la información introducida, espere un momento',
            'GUARDADO': 'Se guardaron los datos correctamente'
          }
        },
        'ETI_EMPRE':'Empresa:',
        'CONTAC':'Contactanos:',
        'CONTAC_DES':'En que podemos ayudarte?',
        'SEND_EMA':'Envia un mensaje',
        'LABEL':'Descripción',
        'TEX_BTN_SEND':'Enviar',
        'MODA_SEN_EMAI':'Enviando mensaje...',
        'SUCC_MODA_SEN_EMAI':'El mesaje se envio correctamente ',

    }
  }
};
